module.exports = __webpack_public_path__ + "static/dyskoteka_referencja-9537ffcc5f55fd7dfa8567eb87fb361d.pdf";